import jquery from 'jquery';

global.jQuery = jquery;
var $ = global.jQuery;
window.$ = $;

/*
 * STAT_WIDGET_API_BASE is non-standard for widget-api, but we are using it
 * to avoid repeating the base url when we load the results-page-structure
 */
document.write(
  ` <script>STAT_WIDGET_API_BASE = '${process.env.VUE_APP_STAT_WIDGET_API_BASE}'</script>
    <script>STAT_WIDGET_API_URL = '${process.env.VUE_APP_STAT_WIDGET_API_BASE}' + 'widget-api/'</script>
    <script>STAT_DATA_API_URL='${process.env.VUE_APP_STAT_DATA_API_URL}'</script>
    <script>STAT_HOME = '${process.env.VUE_APP_STAT_HOME}'</script>
    <script src='${process.env.VUE_APP_STAT_WIDGET_API_BASE}widget-api/widget_api.js'></script>
  `
);

// eslint-disable-next-line
window.changeLocale = function (locale) {
  window.STAT_LOCALE = locale;
  if ($.i18n) {
    $.i18n().locale = locale;
  }
};
